// ─── Promo Code Endpoints ─────────────────────────────────────────────────────

export const API_GET_ALL_PROMOCODE = '/adminSetting/getPromoCodeList/';
export const API_ADD_PROMOCODE = '/adminSetting/addPromoCode/';
export const API_EDIT_PROMOCODE = '/adminSetting/editPromocode/';
export const API_UPDATE_PROMOCODE_STATUS = '/adminSetting/updatePromocodeStatus/';
export const API_GET_PROMOCODE = '/adminSetting/getPromocodeDetails/';
export const API_DELETE_PROMOCODE = '/adminSetting/promocodeDelete/';
